<template>
<b-row class="menu no-gutters">

    <b-col class="tool-border" cols="12">
 <tedtfHeader :image="'menu'" :screenTitle="'TED Triggers and Flares Menu'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">
                   <b-col class="reduce-padding" cols="12">
                       <div class="main-text">
                           <p><b>Choose from the options below to learn more about TED triggers and flares, or select the “NEXT” button to continue.</b></p>
                       </div>        
                    </b-col>
                    <div class="container">
                        <b-row class="five-items no-gutters">
                           <b-row class="no-gutters"> 
                           <div class="microscope"  @click="navigateTo('background');tagNav('Background Icon','Menu');" ></div>
                           <div class="text" @click="navigateTo('background');tagNav('Background Link','Menu');"><b>Background</b></div>
                        </b-row>
                           <b-row class="no-gutters pencil-margin"> 
                           <div class="pencil"   @click="navigateTo('riskFactors');tagNav('Risk Factors You Can Change Icon','Menu');"></div>
                           <div class="p-text"   @click="navigateTo('riskFactors');tagNav('Risk Factors You Can Change Link','Menu');"><b> Risk Factors You Can Change</b></div>
                           </b-row>
                           <b-row class="no-gutters pdf-margin"> 
                           <div class="pdf"   @click="navigateTo('tedFlares');tagNav('Triggers for TED Flares Icon','Menu');"></div>
                           <div class="p-text"   @click="navigateTo('tedFlares');tagNav('Triggers for TED Flares Link','Menu');"><b>Triggers for TED Flares</b></div>
                           </b-row>
                           <b-row class="no-gutters summary-margin"> 
                           <div class="summary"   @click="navigateTo('summary');tagNav('Summary Icon','Menu');"></div>
                           <div class="p-text"   @click="navigateTo('summary');tagNav('Summary Link','Menu');"><b>Summary</b></div>
                           </b-row>
                       </b-row>
                   </div>
                </div>
            </b-row>
        </b-col>
        
        <tedftNavigation v-bind:navButtons="['next','back', 'showMidCol']" :currentScreen="1"  :isSymptom="true" :isHideMenu="true" :isMenuPage="true"></tedftNavigation>
    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
import taggingMixin from "../mixins/taggingMixin";
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';
       
    export default {
        name: "MenuPage",
        mixins: [taggingMixin],
        mounted: function() {
  
        },
        components: {   
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation
            },

        computed: {
            // ...mapGetters('userData', ['userData'])
        },

        methods: {
             navigateTo(screen) {
             this.$router.push(screen);
  }
        },

        data() {
            return {
                  
            };
        },
    };
</script>


<style lang="scss" scoped>
</style>
